import React, { useState } from 'react';
import './NewsLetter.css';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import newsData from '../data/newsData';

const ArticlesList = ({ items }) => {
  const rows = [];
  let i = 0;

  while (i < items.length) {

    const position = i % 4;

    if (position === 0) {

      rows.push(
        <div className="articleRow single" key={`row-${i}`}>
          <ArticleCard article={items[i]} />
        </div>
      );
      i++;
    } else if (position === 1 && i + 1 < items.length) {

      rows.push(
        <div className="articleRow double" key={`row-${i}`}>
          <ArticleCard article={items[i]} />
          <ArticleCard article={items[i + 1]} />
        </div>
      );
      i += 2;
    } else if (position === 1) {

      rows.push(
        <div className="articleRow single" key={`row-${i}`}>
          <ArticleCard article={items[i]} />
        </div>
      );
      i++;
    } else {

      rows.push(
        <div className="articleRow single" key={`row-${i}`}>
          <ArticleCard article={items[i]} />
        </div>
      );
      i++;
    }
  }

  return rows;
};

const ArticleCard = ({ article }) => {
  const handleCardClick = () => {
    if (article.articleLink) {
      window.open(article.articleLink, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div 
      className="articleCard" 
      onClick={handleCardClick}
      style={{ cursor: article.articleLink ? 'pointer' : 'default' }}
    >
      {article.imageSrc ? (
        <img
          src={article.imageSrc}
          alt={article.title}
          className="articleImage"
        />
      ) : (
        <div className="articleImage placeholder">
          <span className="placeholderText">{article.title}</span>
        </div>
      )}
      <div className="articleBody">
        <p className="articleTitle">{article.title}</p>
        <p className="articleDescription">Brief description of the article content goes here.</p>
        {article.articleLink ? (
          <a
            href={article.articleLink}
            target="_blank"
            rel="noopener noreferrer"
            className="readMore"
            onClick={(e) => e.stopPropagation()}
          >
            Read More
          </a>
        ) : null}
      </div>
    </div>
  );
};

const NewsLetter = () => {
  const [filter, setFilter] = useState('all');

  const renderArticles = () => {
    if (filter === 'jobs') {
      return <ArticlesList items={newsData.jobs} />;
    }
    if (filter === 'archive') {
      return <ArticlesList items={newsData.archive} />;
    } return (
      <>
        <ArticlesList items={newsData.jobs} />
        <ArticlesList items={newsData.archive} />
      </>
    );
  };

  return (
    <div className="newsContainer">
      <div className="newsHeader">
        <p className="headerTitle">Newsletter</p>
        <p className="headerSub">
          Exploring Ideas, Insights, and Behind-the-Scenes <br /> Perspectives
        </p>
        <div className="newsDesc">
          <p className="newsDescText">
            Our <b>Jobs Edition Newsletter</b> is a fortnightly newsletter that
            compiles job postings on our WhatsApp groups and delivers them
            straight to your inbox. Our previous editions have focused on
            various aspects of economic and social development through a gender
            lens, such as gender differences in time-use, female entrepreneurship,
            the gig economy, social exclusion, and climate change.
          </p>
        </div>
      </div>

      <div className="articlesContainer">
        <div className="filter">
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label" className="filterTitle">
              Filter
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={filter}
              name="radio-buttons-group"
              onChange={(e) => setFilter(e.target.value)}
            >
              <FormControlLabel
                value="all"
                control={<Radio sx={{ color: 'black', '&.Mui-checked': { color: 'black' } }} />}
                label="All"
                className="filterValue"
              />
              <FormControlLabel
                value="jobs"
                control={<Radio sx={{ color: 'black', '&.Mui-checked': { color: 'black' } }} />}
                label="Jobs"
                className="filterValue"
              />
              <FormControlLabel
                value="archive"
                control={<Radio sx={{ color: 'black', '&.Mui-checked': { color: 'black' } }} />}
                label="Archive"
                className="filterValue"
              />
            </RadioGroup>
          </FormControl>
        </div>

        <div className="articles">
          {renderArticles()}
        </div>
      </div>
    </div>
  );
};

export default NewsLetter;